import React from 'react';
import FaqQuestion from './FaqQuestion';

const Faq = () => {
  const faqQuestions = [
    {
      question: 'What is SEO?',
      answer:
        'Search Engine Optimization(SEO) is the practice of improving the ranking of a website on search engines like Google. The goal is to increase website visibility through website optimization services. This will attract more visitors and improve the chances of converting them into customers. This is done by optimizing content and website structure. National SEO services involve implementing SEO techniques to enhance a websites presence at a level reaching out to an audience, across the entire country instead of concentrating solely on local or regional markets.',
    },
    {
      question: 'How long does it take to see results from SEO services provided by a reliable SEO company?',
      answer:
        'Search engine optimization is a long-term strategy. It usually takes a few months to notice big changes in search rankings. This is due to factors such as industry competition, website conditions, and search engine algorithm updates that affect our SEO efforts. However, some initial improvements might be visible within a few weeks as part of our approach to SEO. To achieve and maintain meaningful results, a minimum commitment of 6 months is generally required for professional SEO services, allowing time for strategies to take effect and optimizations to be made based on evolving data.',
    },
    {
      question: 'Do I need SEO for my business?',
      answer:
        "If you have a business website, it's crucial to use professional SEO services. These services will help improve your website's visibility online and enhance your SEO efforts. They will also attract more visitors and ultimately turn them into customers. It's a crucial component of digital marketing that supports brand awareness, engagement, and conversions. However, if you still need to get a website, SEO won't be applicable. Initially, you'll need website development services from a professional SEO company to establish a digital presence that can then be optimized for search engines.",
    },
    {
      question: 'Can I do SEO on my own?',
      answer:
        'You need specialized knowledge for more advanced SEO strategies, even though you can implement basic practices on your own with free SEO resources. Working with an award-winning SEO service agency can help you compete better and achieve long-lasting results with their expertise and insights.',
    },
    {
      question: 'How do you measure SEO success?',
      answer:
        "We measure professional SEO services' success by tracking a variety of metrics such as keyword rankings, organic traffic, user engagement rates, and conversion rates. To ensure precise and comprehensive data for our SEO team, we use paid subscriptions to advanced SEO tools like Semrush and Ahrefs. These tools help us evaluate how well our plans are working and make decisions based on data to improve them further.",
    },
    {
      question: 'How much do SEO services cost for guaranteed results?',
      answer:
        "The cost of professional SEO services varies depending on your business's specific needs and goals. On average, businesses typically invest between $1,875 to $5,000 per month for comprehensive Search Engine Optimization services. For SEO consulting, hourly rates can range from $100 to $300. This variation reflects different service scopes from basic enhancements to extensive ongoing strategies.",
    },
  ];
  return (
    <div className="bg-white">
      <div className="container">
        <div className="flex flex-col h-full w-full justify-center py-[48px] gap-[48px]">
          <h4 className={'font-[700] text-[24px] md:text-[34px] leading-[28px] md:leading-[44px] text-black md:text-center'}>
            FAQs: Guaranteed SEO Services
          </h4>
          <div className="flex flex-col gap-[16px]">
            {faqQuestions.map((item, index) => (
              <FaqQuestion key={index} question={item.question} answer={item.answer} defaultOpen={index === 0} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Faq;
